import { HashRouter, Routes, Route, Outlet } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { GameProvider } from './context/GameContext'
import { ToastProvider } from './components/ui/Toaster'
import Layout from './components/Layout'
import Home from './pages/Home'
import DailyGame from './pages/DailyGame'
import Duel from './pages/Duel'
import DuelLobby from './pages/DuelLobby'
import DuelGame from './pages/DuelGame'
import DuelResult from './pages/DuelResult'
import Profile from './pages/Profile'
import UGCSubmit from './pages/UGCSubmit'
import Settings from './pages/Settings'
import NotFound from './pages/NotFound'
import Leaderboard from './pages/Leaderboard'
import { useAuth } from './context/AuthContext'

function ProtectedRoute() {
  const { loading } = useAuth()
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface-50 dark:bg-surface-950">
        <div className="flex flex-col items-center gap-4">
          <div className="w-12 h-12 border-4 border-brand-500 border-t-transparent rounded-full animate-spin" />
          <p className="text-surface-600 dark:text-surface-400">Loading...</p>
        </div>
      </div>
    )
  }
  
  // DEMO MODE: Allow access without authentication
  return <Outlet />
}

function App() {
  return (
    <HashRouter>
      <AuthProvider>
        <GameProvider>
          <ToastProvider>
            <Routes>
              <Route element={<Layout />}>
                <Route element={<ProtectedRoute />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/daily" element={<DailyGame />} />
                  <Route path="/duel" element={<Duel />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/ugc" element={<UGCSubmit />} />
                  <Route path="/settings" element={<Settings />} />
                </Route>
                <Route path="/duel/:inviteCode" element={<DuelLobby />} />
                <Route path="/duel/:inviteCode/play" element={<ProtectedRoute />}>
                  <Route path="" element={<DuelGame />} />
                </Route>
                <Route path="/duel/:inviteCode/result" element={<ProtectedRoute />}>
                  <Route path="" element={<DuelResult />} />
                </Route>
                            <Route path="/leaderboard" element={<Leaderboard />} />
                            <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </ToastProvider>
        </GameProvider>
      </AuthProvider>
    </HashRouter>
  )
}

export default App